import { ViewportScroller } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ShebaSkipToDirective } from './href-goto.directive';

@Component({
  selector: 'sheba-skip-to-main-content',
  standalone: true,
  templateUrl: 'skip-to-main-content.component.html',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, ShebaSkipToDirective],
  host: {
    class: 'contents'
  }
})
export class ShebaSkipToMainContentComponent {
  viewportScroller = inject(ViewportScroller);
}
